<section layout="row" [ngClass]="styles.wrapper">

	<vb-ui-checkbox name="allSelected" [ngClass]="styles.chkBox" [(ngModel)]="selectAllPlaylists" (ngModelChange)="onSelectAllPlaylistsChange.emit(selectAllPlaylists)">
	</vb-ui-checkbox>

	<div flex="1 1 0">
		<a [ngClass]="[styles.name, sortInfo.sortAscending ? 'up' : '']" (click)="onSortChange.emit()">
			<span>{{ 'Name' | translate }}</span>
			<span class="caret"></span>
		</a>
	</div>

	<button type="button" [ngClass]="styles.btnNew" vbUiBtnPrimaryNgx (click)="onAddNewClick.emit()">
		{{ 'New' | translate }}
	</button>

</section>
